/* LAB28 motion: scroll-reveal sekcji strony glownej. Wzorzec odporny:
   1) sekcje above-fold oznaczane NATYCHMIAST (stagger 50 ms przez
      transition-delay, zero setTimeout race) - nigdy nie czekaja na observer,
   2) observer z threshold 0 (kazdy piksel przeciecia odpala; poprzedni
      threshold 0.06 liczyl prog jako ulamek wysokosci sekcji i sekcje
      czesciowo widoczne przy load nie przekraczaly go az do scrolla),
   3) fallback 1200 ms: jesli observer nie dal zadnego callbacku (zawiodl),
      odslon wszystko - strona nigdy nie zostaje pusta.
   Wylaczone przy prefers-reduced-motion oraz w theme editorze.
   Bez JS strona jest w pelni widoczna (klasa .lab28-reveal dodawana tutaj). */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var main = document.querySelector('main[data-template="index"]');
  if (!main) return;

  var sections = Array.prototype.slice.call(
    main.querySelectorAll(':scope > .shopify-section')
  );
  if (!sections.length) return;

  var reveal = function (el) {
    el.classList.add('lab28-inview');
  };
  var isRevealed = function (el) {
    return el.classList.contains('lab28-inview');
  };

  main.classList.add('lab28-reveal');

  // 1. Above-fold: oznacz od razu, animacja wchodzi ze staggerem 50 ms
  //    (transition-delay zamiast setTimeout - bez wyscigu z observerem).
  var vh = window.innerHeight || document.documentElement.clientHeight;
  var idx = 0;
  sections.forEach(function (s) {
    if (s.getBoundingClientRect().top < vh) {
      s.style.transitionDelay = idx * 50 + 'ms';
      reveal(s);
      idx += 1;
    }
  });

  // 2. Reszta: observer, threshold 0 (dowolne przeciecie = reveal).
  var rest = sections.filter(function (s) {
    return !isRevealed(s);
  });
  var ioFired = false;

  if (rest.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        ioFired = true;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -5% 0px', threshold: 0 }
    );
    rest.forEach(function (s) {
      io.observe(s);
    });
  } else {
    rest.forEach(reveal);
    ioFired = true;
  }

  // 3. Fallback bezpieczenstwa: observer w dzialajacej przegladarce ZAWSZE
  //    odpala pierwszy callback tuz po observe() (stan poczatkowy).
  //    Brak callbacku po 1200 ms = observer zawiodl -> odslon wszystko.
  setTimeout(function () {
    if (!ioFired) {
      sections.forEach(function (s) {
        if (!isRevealed(s)) reveal(s);
      });
    }
  }, 1200);

  // Powrot z bfcache: stan klas przezywa, ale gdyby cokolwiek zostalo
  // ukryte nad foldem, odslon.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var vh2 = window.innerHeight || document.documentElement.clientHeight;
    sections.forEach(function (s) {
      if (!isRevealed(s) && s.getBoundingClientRect().top < vh2) reveal(s);
    });
  });
})();
